import { ReactNode } from 'react';
import { DateTimePicker } from 'components/DatePicker/DateTimePicker';
import { startOfTomorrow } from 'date-fns';
import { Controller, useFormContext } from 'react-hook-form';
import { dateToString } from 'utils/common/common';

type TProps = {
  fieldName: string;
  label: (text: ReactNode) => ReactNode;
  error?: string;
  disabled?: boolean;
};

export const DateField = ({ fieldName, label, error, disabled }: TProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={`${fieldName}.lastRepaymentDate`}
      control={control}
      shouldUnregister
      render={({ field: { value, onChange } }) => (
        <DateTimePicker
          fieldInput
          label={label('Last repayment date')}
          error={error}
          disabled={disabled}
          defaultDate={value}
          filterDate={(date) => date >= startOfTomorrow()}
          handleChange={(date) => onChange(date ? dateToString(date) : '')}
        />
      )}
    />
  );
};
